import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html'
})
export class ErrorDialogComponent implements OnInit {
  public messageHeader: string;
  public messageContent: string;

  constructor(public dialog: NgbActiveModal) {}

  public ngOnInit(): void {}

  public onCancel(): void {
    this.dialog.dismiss();
  }

  public onSubmit(): void {
    this.dialog.close(this.messageContent);
  }
}
